module.exports = __webpack_public_path__ + "static/media/Entypo.31b5ffea.ttf";